'use client';

import submitContactForm from '@/actions/contact-form';
import { formField } from '@/lib/util/form-field';
import { useTheme } from '@/providers/theme-provider';
import Button from '@/ui/Button/Button';
import Input from '@/ui/FormElements/Input';
import TextArea from '@/ui/FormElements/TextArea';
import { CircleX } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useActionState } from 'react';
import Turnstile from 'react-turnstile';
import styles from '../page.module.scss';
import formStyles from './ContactForm.module.scss';

export type ContactFormProps = {};

const ContactForm: React.FC<ContactFormProps> = () => {
  const t = useTranslations('contact.form');

  const [state, submitContactFormAction, pending] = useActionState(submitContactForm, null);
  const field = formField(state?.data, state?.error);

  const { theme } = useTheme();

  return (
    <form className={styles.contactForm} action={submitContactFormAction}>
      <Input {...field('name')} label={t('name')} />
      <Input {...field('email')} label={t('email')} />
      <TextArea {...field('message')} label={t('message')} />
      <div className={formStyles.cfTurnstileContainer}>
        <Turnstile sitekey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY} theme={theme} />
        {state?.error.fieldErrors['cf-turnstile-response'] && (
          <span className={formStyles.errorLabel}>
            <CircleX size={14} />
            <span>{state?.error.fieldErrors['cf-turnstile-response']}</span>
          </span>
        )}
      </div>

      <Button type="submit" disabled={pending} data-umami-event="submit-contact-form">
        {t('submit')}
      </Button>
    </form>
  );
};

export default ContactForm;
